import { Form, Formik } from "formik";
import FormField from "../forms/FormField";
import * as Yup from "yup";
import { useEffect, useMemo, useRef, useState } from "react";
import { toast } from "react-toastify";
import { TailwindSpinner } from "../Spinner/Spinner";
import { DownloadModal } from "../DownloadModal";
import MemberEnrollmentTable from "../MemberEnrolements/MemberEnrolmentTable";
import {
  RedeemptionReportColumn,
} from "../Table/TableColums";
import { useGetRedeemptionReport } from "../../hooks/Query/useGetAllRedeemptionReport";
import { downloadFile } from "../../utils/downloadFile";
import { useDownloadTransactionReport } from "../../hooks/Query/useDownloadTransactionReport";
import { downloadRedemptionReport } from "../../service/query/auth";
import { useDownloadRedemptionReport } from "../../hooks/Query/useDownloadRedeemptionReport";

const validationSchema = Yup.object({
  fromDate: Yup.date().required("From date is required"),
  tillDate: Yup.date().required("Till date is required"),
  report: Yup.number().required("Campaign is required"),
  limit: Yup.string(),
});

const initialValues = {
  fromDate: "",
  tillDate: "",
  report: "0",
  limit: "",
};
export default function GetRedemptionReport() {
  const [page, setPage] = useState(1);
  const [payloadData, setPayloadData] = useState();
  const [formData, setFormData] = useState(initialValues);
  const [loyaltyPrograms, setLoyaltyPrograms] = useState();
  const [showDownloadOption, setShowDownloadOption] = useState(false);
  const [downloadFormat, setDownloadFormat] = useState("");
  const [shouldDownload, setShouldDownload] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [redeemptionReport, setRedeemptionReport] = useState([]);
  const [downloadPayload, setDownloadPayload]=useState()
  const [newDownloadData, setNewDownloadData] = useState()
  const formikRef = useRef();

  // GET REPORT
  const {
    data: report,
    isFetching: loading,
    refetch,
  } = useGetRedeemptionReport({
    payload: payloadData,
    page: page,
  });


    // DOWNLOAD REPORT
    const { data: downloadData, isLoading } = useDownloadRedemptionReport({
      payload: downloadPayload
    });

  // Sync formData with Formik values
  useEffect(() => {
    const interval = setInterval(() => {
      if (formikRef.current?.values) {
        setFormData(formikRef.current.values);
      }
    }, 300);
    return () => clearInterval(interval);
  }, []);

  // Show download modal if limit is "All"
  useEffect(() => {
    if (formData?.limit === "All") {
      setOpenModal(true);
      setShowDownloadOption(false);
    }
  }, [formData]);

  const payload = useMemo(
    () =>
      `from_date=${formData?.fromDate}&to_date=${formData?.tillDate}&report_type=${formData?.report}`,
    [formData]
  );

  useEffect(() => {
    if (!loading && report?.data) {
      const nairaValue = report?.data?.data?.map(
        (value) => value?.ReferenceID === "E0PNVfgGycNp" ?  value?.Redeem_points : value?.Redeem_points / 2
      );

      const newValue = report?.data?.data?.map((item, idx) => ({
        ...item,
        Naira_value:nairaValue[idx],
      }));
   
      setRedeemptionReport(newValue);
    }
  }, [loading, report]);

  const handleShowDownloadReport = (value) => {
    if (!value) {
      return toast.error("Kindly fill all required filleds.");
    } else {
      setShowDownloadOption(!showDownloadOption);
    }
  };

  const handleDownloadReport = (values, format) => {
    if (values?.fromDate === "" || values?.tillDate === "" ||values?.report === 0 || values?.limit  === "" ) {
      toast.error("Fill all required fields");
      return;
    }
    setDownloadPayload(values);
    setDownloadFormat(format);
    setShouldDownload(true);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
    refetch();
  };

console.log("downloadData", downloadData)

    useEffect(() => {
      if (shouldDownload && downloadData?.data?.data?.length > 0) {
         const nairaValue = downloadData?.data?.data?.map(
        (value) => value?.ReferenceID === "E0PNVfgGycNp" ?  value?.Redeem_points : value?.Naira_value
      );   
        const data = downloadData?.data?.data?.map((item, idx) => ({
          ...item,
          Naira_value:nairaValue[idx],
        }))
      
        downloadFile({
          data:data,
          format: downloadFormat,
          fileName: `FirstRewards Redemption Report ${downloadPayload?.fromDate} - ${downloadPayload?.tillDate}`,
        });
  
        setShouldDownload(false);
      } else if (
        shouldDownload &&
        !isLoading &&
        !downloadData?.data?.data?.length
      ) {
        toast.warning("No data available to download.");
        setShouldDownload(false);
      }
    }, [downloadData, shouldDownload, downloadFormat, isLoading, downloadPayload, newDownloadData]);
  return (
    <div className="max-w-7xl mx-auto p-4 md:p-6 bg-white rounded-lg">
      <div className="mb-6">
        <h1 className="text-lg font-medium text-gray-900">
          Partner Redemption Report
        </h1>
        <p className="text-grey-200 text-sm">
          View all redemption report in the program
        </p>
      </div>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          setPayloadData(values);
        }}
      >
        {({ values, errors }) => {
     
          return (
            <Form className="md:w-[711px] relative h-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                <FormField
                  label="From Date"
                  name="fromDate"
                  type="date"
                  required={true}
                />
                <FormField
                  label="Till Date"
                  name="tillDate"
                  type="date"
                  required={true}
                />
                <FormField
                  label="Report Type"
                  name="report"
                  type="select"
                  options={[
                    { value: 0, label: "Point to cash"},
                    { value: 1, label: "BAP" },
                    { value: 2, label: "Uber voucher"},
                    { value: 3, label: "All" },
                  ]}
                  required={true}
                />
                {showDownloadOption && (
                  <FormField
                    label="Download Limit"
                    name="limit"
                    type="select"
                    options={[
                      { value: "100000", label: "100,000" },
                      { value: "200000", label: "200,000" },
                      { value: "500000", label: "500,000" },
                        { value: "1000000", label: "1,000,000" },
                      { value: "All", label: "All" },
                    ]}
                  />
                )}
              </div>

              <div className="flex flex-col md:flex-row gap-4 mt-6 justify-between items-center">
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-mysecondary hover:bg-blue-800 text-white px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm"
                >
                  {loading ? <TailwindSpinner /> : "Search"}
                </button>
                <div>
                  <button
                    type="button"
                    disabled={isLoading}
                    variant="outline"
                    className=" text-center  border-1 border-mysecondary text-blue-900 hover:bg-blue-50 px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm "
                    onClick={() => handleShowDownloadReport(values)}
                  >
                    {/* <Download className="mr-2 h-4 w-4" /> */}
                    {" Download As"}
                  </button>
                </div>
              </div>
              {showDownloadOption && (
                <div className="flex justify-center  md:justify-end ">
                  <div className="  right-0 mt-2 text-center  border-1 border-mysecondary text-blue-900 hover:bg-blue-50 rounded flex items-center  justify-end w-[189px]  flex-col">
                    <button
                      type="button"
                      disabled={isLoading}
                      className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white flex justify-center items-center"
                      onClick={() => handleDownloadReport(values, "pdf")}
                    >
                      {isLoading && downloadFormat === "pdf" ?  <TailwindSpinner/> : "Pdf"}
                    </button>
                    <button
                      type="button"
                      disabled={isLoading}
                      className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white flex justify-center items-center"
                      onClick={() => handleDownloadReport(values, "csv")}
                    >
                      {isLoading && downloadFormat === "csv" ? <TailwindSpinner/> : "Csv"}
                    </button>
                  </div>
                </div>
              )}
            </Form>
          );
        }}
      </Formik>

      {report && redeemptionReport?.length > 0 ? (
        <MemberEnrollmentTable
          columns={RedeemptionReportColumn}
          data={redeemptionReport}
          page={page}
          setPage={setPage}
          handlePageChange={handlePageChange}
          totalPage={report?.data?.pagination?.total}
          total_pages={report?.data?.pagination?.total_pages}
          loading={loading}
          title={"Redemption"}
        />
      ) : report && report?.data?.data?.length === 0 ? (
        <div className="text-center text-gray-500 mt-10">
          No data available for the selected criteria.
        </div>
      ) : null}
      {openModal && (
        <DownloadModal
          setOpenModal={setOpenModal}
          value={formData}
          openModal={openModal}
          payload={payload}
        />
      )}
    </div>
  );
}
